var _ellipse, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 93,
    viewBox: "0 0 156 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.4671,
    cy: 84.3413,
    rx: 71.1377,
    ry: 7.81437,
    fill: "#E6E7E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1975 19.4012V34.7605L57.2514 42.0359V19.4012H39.1975Z",
    fill: "#8FC549"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.449 11.0479V46.0779L81.5029 53.3533V11.0479H63.449Z",
    fill: "#E75766"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2395 0V56.0479L106.293 63.3233V0H88.2395Z",
    fill: "#8FC549"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.395264 68.1736V87.3054L37.3114 57.3952L107.102 87.3054L143.21 60.3593L146.443 68.1736L155.335 40.9581L127.85 45.5389L135.126 48.7724L107.102 69.2515L37.3114 38.8024L0.395264 68.1736Z",
    fill: "#126BA5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f6eb4d95.svg";
export { ForwardRef as ReactComponent };